<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" md="4">
        <v-card class="text-center">
          <v-card-title>QR HOME</v-card-title>
          <img v-if="homeQr" :src="homeQr">
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="text-center">
          <v-card-title>QR ORDER</v-card-title>
          <img v-if="orderQr" :src="orderQr">
        </v-card>

      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import QrProvider from "@/modules/delivery/providers/QrProvider";

export default {
  name: "QrPage",
  data(){
    return {
      homeQr: null,
      orderQr: null
    }
  },
  created() {
    this.qrHome()
    this.qrOrder()
  },
  methods: {
    qrHome() {
      QrProvider.qrHome()
          .then(r => {
            this.homeQr = r.data.qrHome
          })
    },
    qrOrder() {
      QrProvider.qrOrder()
          .then(r => {
            this.orderQr = r.data.qrOrder
          })
    }
  }
}
</script>

<style scoped>

</style>
